import axios from './axiosInstances/axiosInstance';

export const getTransferBasketId = (basketId, restaurantId) => {
  return axios.post(`/baskets/${basketId}/transfer`, {
    restaurantid: restaurantId,
  });
};
